import CustomerSearch from "@@/core/components/shared/CustomerSearch/CustomerSearch";
import { BFormGroup, BTable, BForm } from "bootstrap-vue";

export default {
  name: "pointsEarned",
  components: {
    CustomerSearch,
    BTable,
    BFormGroup,
    BForm,
  },

  data() {
    return {
      disabled: false,
      url: "admin/reports/customers-club-scores",
      items: [],
      totals: null,
      form: {
        selectedCustomer: "",
        from_date: "",
        to_date: "",
        type: "",
      },
      typeOptions: [
        { value: "", text: "همه" },
        { value: "increase", text: "بن دریافتی" },
        { value: "decrease", text: "بن خرج شده" },
      ],
      fields: [
        { label: "ردیف", key: "row_number" },
        { label: "شناسه", key: "id" },
        { label: "شناسه مشتری", key: "customer_id" },
        { label: "نام مشتری", key: "customer_name" },
        { label: "شماره تماس", key: "mobile" },
        { label: "نوع سفارش", key: "order_type" },
        { label: "امتیاز", key: "score_value" },
        { label: "بن", key: "bon_value" },
        { label: "بن لغو شده", key: "bon_canceled" },
        { label: "عنوان", key: "cause_title" },
        { label: "تاریخ", key: "date" },
      ],
    };
  },

  created() {
    // بار اول همه را نشان بده
    this.loadUserPointsList();
  },

  methods: {
    buildParams() {
      const f = this.form;
      const params = {};
      if (f.selectedCustomer && f.selectedCustomer.id) {
        params.customer_id = f.selectedCustomer.id;
      }
      if (f.from_date) params.from_date = f.from_date;
      if (f.to_date) params.to_date = f.to_date;
      if (f.type) params.type = f.type;
      return params;
    },

    async loadUserPointsList() {
      this.disabled = true;
      await this.$axios
        .get(this.url, { params: this.buildParams() })
        .then((res) => {
          const data = res.data.data;
          this.items = data.reports || [];
          this.totals = data.totals || null;
          this.$root.notify(res.data.message, "success");
        })
        .catch((err) => {
          this.$root.notify(err);
        })
        .finally(() => {
          this.disabled = false;
        });
    },

    resetFilters() {
      this.form = {
        selectedCustomer: "",
        from_date: "",
        to_date: "",
        type: "",
      };
      this.loadUserPointsList();
    },
  },
};
